export { HalfScreenHero, type HalfScreenHeroProps } from './HalfScreenHero';
